import script from "./balanceLowerSet.vue?vue&type=script&lang=ts&setup=true"
export * from "./balanceLowerSet.vue?vue&type=script&lang=ts&setup=true"

import "./balanceLowerSet.vue?vue&type=style&index=0&id=3052a8ea&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3052a8ea"]])

export default __exports__